export class DocumentTupleFile {
    public file: File;

    constructor(file?: File) {
        this.file = !file ? null : file;
    }
}
